<template>
  <div class="mobile-button"  @click="previousPage" v-bind:class="[previousClass]">
    <label>{{pText}}</label>
  </div>
</template>

<script>
export default {
  name: 'mobileButton',
  props: {
    pText: String,
    pColor: String,
    nText: String,
    nColor: String
  },
  methods: {
    previousPage() {
      this.$emit('previousPage');
    },
   },
   computed: {
     nextClass() {
       return {
           'gray' : this.nColor === 'gray',
           'green' : this.nColor === 'green',
           'blue' : this.nColor === 'blue',
           'yellow' : this.nColor === 'yellow',
           'disabled' : this.nColor === 'gray'
       }
     },
     previousClass() {
       return {
           'gray' : this.pColor === 'gray',
           'green' : this.pColor === 'green',
           'blue' : this.pColor === 'blue',
           'yellow' : this.pColor === 'yellow',
           'disabled' : this.pColor === 'gray',
       }
     },
   }
  }
</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mobile-button {
    top: 1em;
    left: 1em;
    height: 35px;
    width: 70px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  	position: fixed;
    cursor: pointer;

    label {
      color: white;
    	font-size: $font-semiLarge;
    	font-weight: bold;
    }

  }

  .yellow {
  	background-color: $yellow;
  }

  .gray {
   background-color: $greyest;
  }

  .green{
   background-color: $green;
  }

  .blue{
   background-color: $cyan;
  }

  @media screen and (min-width: 1140px) {

    .mobile-button {
      display: none;
    }
  }

</style>
